import { useCallback, useState } from "react";
import { TABLE_PAGE_SIZE } from "../../constants/tables";

export function useVisibleWindow<T>(rows: T[], resetKey: unknown = rows.length) {
  const key = String(resetKey);
  const [state, setState] = useState({ key, count: TABLE_PAGE_SIZE });
  if (state.key !== key) {
    setState({ key, count: TABLE_PAGE_SIZE });
  }
  const count = state.key === key ? state.count : TABLE_PAGE_SIZE;

  const loadMore = useCallback(() => {
    setState((current) =>
      current.key === key ? { key, count: current.count + TABLE_PAGE_SIZE } : current,
    );
  }, [key]);

  const items = rows.slice(0, count);
  return {
    items,
    hasMore: items.length < rows.length,
    loadingMore: false,
    loadMore,
  };
}
